'use strict';

wbApp.factory('activityAttendanceSvc', ['$resource', '$q', '$translate', '$filter', 'repositorySvc',
    'notificationSvc', 'studentSvc', 'tenantSettingSvc', 'activitySvc',
function ($resource, $q, $translate, $filter, repositorySvc, notificationSvc, studentSvc, tenantSettingSvc, activitySvc) {

    var ActivityAtendances = $resource('/Api/ActivityAttendance/:id', {}, {
        'getAttendancesBySchedule': { method: 'GET', isArray: false, url: '/Api/ActivityAttendance/GetAttendancesBySchedule' },
        'getActivitySchedules': { method: 'GET', isArray: false, url: '/ActivityAttendance/GetActivitySchedules' },
        'updateScheduleNotes': { method: 'POST', url: '/Api/ActivitySchedules/UpdateSchedulePublicNote' },
        'getStudentAttendanceDetail': { method: 'GET', isArray: false, url: '/Api/ActivityAttendance/GetAttendanceDetail' },
        'excuseStudent': { method: 'POST', isArray: false, url: '/Api/ActivityAttendance/ExcuseStudent' },
        'save': { method: 'POST', url: '/Api/ActivityAttendance/Save', isArray: false },
        'delete': { method: 'POST', url: '/Api/ActivityAttendance/Delete', isArray: false },
    });

    function filterAndBreakByMonth(schedules, activityID) {
        var months = {};

        var filtered = $filter('orderBy')(schedules, 'startDate');

        for (var s = 0; s < filtered.length; s++) {
            var schedule = filtered[s];
            if (schedule.activityID !== activityID) {
                continue;
            }

            var mStartDate = moment(schedule.startDate);
            var key = (mStartDate.year() << 16) | mStartDate.month();

            var mSchedules = months[key];
            if (!mSchedules) {
                mSchedules = [];
                months[key] = mSchedules;
            }

            mSchedules.push(schedule);
        }

        var ret = [];
        for (var key in months) {
            var month = months[key];
            ret.push({
                startDate: new Date(key >> 16, key & 0x0000FFFF, 1),
                schedules: month
            });
        }

        return $filter('orderBy')(ret, 'startDate');
    }

    function getExcusesAndAmendsOnly(schedules, activityID) {
        return $filter('orderBy')(_.filter(schedules, { activityID: activityID, isNotRegularAttendance: true }), 'startDate');
    }

    function findByProperty(collection, propertyName, value) {
        for (var i = 0; i < collection.length; i++) {
            var entity = collection[i];
            if (entity[propertyName] == value) {
                return entity;
            }
        }

        return null;

    }

    function findByStudentID(collection, studentID) {
        return findByProperty(collection, 'studentID', studentID);
    }

    function addNewStudent(attendances, schedule, studentID) {
        var deferred = $q.defer();

        var currentAttendance = findByStudentID(attendances, studentID);
        if (!!currentAttendance) {
            notificationSvc.notifyError($translate.instant('TXT_ALERT_TITLE_STUDENT_ALREADY_IN_ATTENDANCE'));

            deferred.resolve();
            return deferred.promise;
        }

        $q.all([
            activitySvc.getByActivityID(schedule.activityID).$promise,
            studentSvc.getByIDAsync(studentID).$promise]).then(function (data) {

                var activity = data[0];
                var student = data[1];

                var newAttendance = {
                    studentFullName: student.fullName,
                    studentID: studentID,
                    activityScheduleID: schedule.activityScheduleID,
                    activityID: schedule.activityID,
                    firstPeriodStartDate: null,
                    firstPeriodEndDate: null,
                    secondPeriodStartDate: null,
                    secondPeriodEndDate: null,
                    lunch: false,
                    firstSnack: false,
                    secondSnack: false,
                    notes: null,
                    confirmed: null,

                    firstPeriodAttendanceStatusID: 1,
                    secondPeriodAttendanceStatusID: 1,
                    firstPeriodAttendanceTypeID: 0,
                    secondPeriodAttendanceTypeID: 0,
                };

                var setting = {
                    activityCompensationTypeID: 0 /* ActivityCompensationType.OneExcuseForOneCompensatio */
                };

                var a = new webooker_acivity_models.ActivityAttendance(
                    schedule,
                    null,
                    newAttendance,
                    setting,
                    activity,
                    tenantSettingSvc.settings,
                    0,
                    studentID);

                attendances.push(a);


            }, function (errorResult) {
            deferred.reject(errorResult);
        });

        return deferred.promise;
    }

    function buildAttendanceModel(
        schedule, 
        reservations, 
        attendances,
        activityStudentSettings,
        activity,
        tenantSetting,
        numberOfExcusesByStudent)
    {
        var dict = {};

        var attendanceByStudentID = _.keyBy(attendances, 'studentID');
        var settingsByStudentID = _.keyBy(activityStudentSettings, 'studentID');
        var excusesByStudentID = _.mapValues(_.keyBy(numberOfExcusesByStudent, 'studentID'), 'noOfExcuses');

        _.forEach(reservations, function (reservation) {
            if (!!reservation) {
                dict[reservation.studentID] = (new webooker_acivity_models.ActivityAttendance(
                    schedule,
                    reservation,
                    attendanceByStudentID[reservation.studentID],
                    settingsByStudentID[reservation.studentID],
                    activity,
                    tenantSetting,
                    excusesByStudentID[reservation.studentID] || 0,
                    reservation.studentID));
            }
        });

        _.forEach(attendances, function (attendance) {
            if (!dict[attendance.studentID]) {
                dict[attendance.studentID] = new webooker_acivity_models.ActivityAttendance(
                    schedule,
                    null,
                    attendance,
                    settingsByStudentID[attendance.studentID],
                    activity,
                    tenantSetting,
                    excusesByStudentID[attendance.studentID] || 0,
                    attendance.studentID);
            }
        });

        return _.values(dict);
    }

    // studentID only if we are building model for single student
    function buildAttendanceModelBySchedules(
        schedules, 
        reservations, 
        attendances,
        activityStudentSetting,
        activity,
        tenantSetting,
        excusesByDate,
        studentID) {

        var rdict = _.keyBy(reservations, 'activityScheduleID');
        var adict = _.keyBy(attendances, 'activityScheduleID');
        var excusesDict = _.keyBy(excusesByDate, function (s) {return +moment(s.date).startOf('day') });
        var result = [];

        _.forEach(schedules, function (schedule) {
            var excuse = excusesDict[+moment(schedule.startDate).startOf('day')];

            result.push(new webooker_acivity_models.ActivityAttendance(
              schedule,
              rdict[schedule.activityScheduleID],
              adict[schedule.activityScheduleID],
              activityStudentSetting,
              activity,
              tenantSetting,
              excuse != null ? excuse.noOfExcuses : 0,
              studentID));
        });

        return result;
    }

    function getAttendancesBySchedule(schedule) {
        var deferred = $q.defer();
        var result = [];
        result.$promise = deferred.promise;

        repositorySvc.customGet('getAttendancesBySchedule', ActivityAtendances, {
            activityID: schedule.activityID,
            activityScheduleID: schedule.activityScheduleID
        }, success, error);

        function success(data) {
            result.push.apply(result, buildAttendanceModel(
                data.schedule,
                data.reservations,
                data.attendances,
                data.setting,
                data.activity,
                tenantSettingSvc.settings,
                data.excuses));
            deferred.resolve(result);
        }

        function error(errorResult) {
            deferred.reject(errorResult);
        }

        return result;
    }

    function getStudentAttendanceDetailAsync(activityID, studentID) 
    {
        var deferred = $q.defer();
        var result = [];

        result.$promise = deferred.promise;

        $q.all([
            activitySvc.getByActivityID(activityID).$promise,
            repositorySvc.customGet('getStudentAttendanceDetail', ActivityAtendances, {
                activityID: activityID,
                studentID: studentID
            }).$promise
        ]).then(function (data) {

            result.push.apply(result,
                buildAttendanceModelBySchedules(
                    data[1].schedules,
                    data[1].reservations,
                    data[1].attendances,
                    data[1].setting,
                    data[0],
                    tenantSettingSvc.settings,
                    data[1].excusesByDate,
                    studentID));
            deferred.resolve(result);

        }, function (error) {
            deferred.reject(error);
        });

        return result;
    }

    function excuseStudent(activityID, studentID, excuseFrom, excuseTo, firstPeriod, secondPeriod, notes) {
        var deferred = $q.defer();
        var result = [];
        result.$promise = deferred.promise;

        $q.all([
            activitySvc.getByActivityID(activityID).$promise,
            ActivityAtendances.excuseStudent({
                activityID: activityID,
                studentID: studentID,
                excuseFrom: excuseFrom,
                excuseTo: excuseTo,
                firstPeriod: firstPeriod,
                secondPeriod: secondPeriod,
                notes: notes
            }).$promise
        ]).then(function (data) {

            notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_DATA_SAVED'));

            result.push.apply(result,
                buildAttendanceModelBySchedules(
                    data[1].schedules,
                    data[1].reservations,
                    data[1].attendances,
                    data[1].setting,
                    data[0],
                    tenantSettingSvc.settings,
                    data[1].excusesByDate,
                    studentID));
            deferred.resolve(result);
        }, function (error) {
            repositorySvc.defaultErrorHandler(error);
            deferred.reject(error);
        });

        return result;
    }

    function saveAttendanceAsync(attendance, checkCapacity) {

        var deferred = $q.defer();
        var result = [];
        result.$promise = deferred.promise;

        var studentID = attendance.origAttendance.studentID;

        $q.all([
            activitySvc.getByActivityID(attendance.activityID).$promise,
            ActivityAtendances.save({
                model: attendance.getServerAttendance(),
                checkCapacity: !!checkCapacity
            }).$promise
        ]).then(function (data) {
            notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_DATA_SAVED'));

            if (!!checkCapacity) {
                // Called from MyActivities
                // Returns single student info for the whole semester
                result.push.apply(result,
                    buildAttendanceModelBySchedules(
                        data[1].schedules,
                        data[1].reservations,
                        data[1].attendances,
                        data[1].setting,
                        data[0],
                        tenantSettingSvc.settings,
                        data[1].excusesByDate,
                        studentID));
            } else {
                // Called from ActivityAttendance
                // Returns single student info for single day
                result.push.apply(result, buildAttendanceModel(
                    data[1].schedule,
                    data[1].reservations,
                    data[1].attendances,
                    data[1].setting,
                    data[0],
                    tenantSettingSvc.settings,
                    data[1].excuses));
            }

            deferred.resolve(result);
        }, function (error) {
            repositorySvc.defaultErrorHandler(error);
            deferred.reject(error);
        });

        return result;
    }

    function getActivitySchedules(semesterID) {
        return repositorySvc.customGet('getActivitySchedules', ActivityAtendances, {
            semesterID: semesterID
        });
    }

    function updateScheduleNotesAsync(activityScheduleID, notes, sendNotification) {
        var res = ActivityAtendances.updateScheduleNotes({
            id: activityScheduleID,
            note: notes,
            sendNotification: sendNotification
        }, success, error);

        function success(data) {
            notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_DATA_SAVED'));
        }

        function error(errorResult) {
            repositorySvc.defaultErrorHandler(errorResult);
        }

        return res;
    }

    function removeFromCollection(attendances, attendance) {
        var idxToRemove = attendances.indexOf(attendance);
        if (idxToRemove > -1) {
            attendances.splice(idxToRemove, 1);
        }
    }

    function deleteAttendanceAsync(attendances, attendance) {
        if (attendance.canBeDeletedWithoutConfirmation) {
            removeFromCollection(attendances, attendance);
        } else {
            ActivityAtendances.delete({
                activityAttendanceID: attendance.activityAttendanceID
            }, success, error);
        }

        function success(data) {
            removeFromCollection(attendances, attendance);
            notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_DATA_SAVED'));
        }

        function error(errorResult) {
            repositorySvc.defaultErrorHandler(errorResult);
        }
    }

    function bookAttendanceByPeriod(attendance, origAttendance, period) {
        if (!origAttendance.shouldDisableFirstPeriodBooking) {
            if (!period.am) {
                // Return to orig state
                attendance.firstPeriodAttendanceStatusID = origAttendance.firstPeriodAttendanceStatusID;
                attendance.firstPeriodAttendanceTypeID = origAttendance.firstPeriodAttendanceTypeID;
            } else {
                if (origAttendance.firstPeriodAttendanceStatusID == 1 &&  // Not present / not excused
                    origAttendance.firstPeriodAttendanceTypeID == 0 &&    // Registered
                    (!origAttendance.reservation || !origAttendance.reservation.firstPeriodStartDate)) {

                    attendance.firstPeriodAttendanceStatusID = 0; // Present
                    attendance.firstPeriodAttendanceTypeID = 2;   // Amend
                } else {
                    attendance.firstPeriodAttendanceStatusID = 0; // Present
                }
            }
        }

        // Second attendance
        if (!origAttendance.shouldDisableSecondPeriodBooking) {
            if (!period.pm) {
                // Return to orig state
                attendance.secondPeriodAttendanceStatusID = origAttendance.secondPeriodAttendanceStatusID;
                attendance.secondPeriodAttendanceTypeID = origAttendance.secondPeriodAttendanceTypeID;
            } else {
                if (origAttendance.secondPeriodAttendanceStatusID === 1 &&  // Not present / not excused
                    origAttendance.secondPeriodAttendanceTypeID == 0 &&    // Registered
                    (!origAttendance.reservation || !origAttendance.reservation.secondPeriodStartDate)) {

                    attendance.secondPeriodAttendanceStatusID = 0; // Present
                    attendance.secondPeriodAttendanceTypeID = 2;   // Amend
                } else {
                    attendance.secondPeriodAttendanceStatusID = 0; // Present
                }
            }
        }
    }

    return {
        getAttendancesBySchedule: getAttendancesBySchedule,
        getActivitySchedules: getActivitySchedules,
        saveAttendanceAsync: saveAttendanceAsync,
        updateScheduleNotesAsync: updateScheduleNotesAsync,
        deleteAttendanceAsync: deleteAttendanceAsync,
        addNewStudent: addNewStudent,
        getStudentAttendanceDetailAsync: getStudentAttendanceDetailAsync,
        filterAndBreakByMonth: filterAndBreakByMonth,
        excuseStudent: excuseStudent,
        bookAttendanceByPeriod: bookAttendanceByPeriod,
        getExcusesAndAmendsOnly: getExcusesAndAmendsOnly
    }

}]);
